import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Button, Checklist } from '@hexure/ui';

const LimitProductTypes = ({
  annuity_quoter, // legacy prop for annuity quoters
  quoter, // generic prop for universal quoters
  handleSave,
  fromUniversalQuoter = false,
  mockProductTypes = []
}) => {
  // Use mock product types if in universal quoter context, else use default
  const all_product_types =
    fromUniversalQuoter && mockProductTypes.length
      ? mockProductTypes
      : ['Fixed Annuity', 'Fixed Indexed Annuity', 'Multi-Year Guaranteed Annuity'];

  // Support both annuity_quoter and generic quoter prop
  const initialProductTypes =
    (quoter && quoter.product_types) || (annuity_quoter && annuity_quoter.product_types) || [];

  const [data, setData] = useState({
    product_types: initialProductTypes
  });

  // Update state if quoter changes (for tab switching)
  useEffect(() => {
    setData({ product_types: initialProductTypes });
  }, [
    quoter && quoter.product_types ? quoter.product_types.join(',') : '',
    annuity_quoter && annuity_quoter.product_types ? annuity_quoter.product_types.join(',') : ''
  ]);

  const handleChecklistChange = e => {
    setData({ ...data, product_types: e.target.value });
  };

  const save = () => {
    handleSave(data);
  };

  return (
    <>
      <div style={{ marginBottom: 30 }}>
        <Checklist
          onChange={handleChecklistChange}
          options={all_product_types.map(pt => ({ value: pt }))}
          selected={data.product_types || []}
        />
      </div>

      <Button disabled={!data.product_types.length} onClick={save}>
        Save Changes
      </Button>
    </>
  );
};

LimitProductTypes.propTypes = {
  annuity_quoter: PropTypes.object, // for universal quoter
  fromUniversalQuoter: PropTypes.bool,
  handleSave: PropTypes.func,
  mockProductTypes: PropTypes.arrayOf(PropTypes.string),
  // legacy
  quoter: PropTypes.object
};

export default LimitProductTypes;
